module.exports = __webpack_public_path__ + "static/media/login.83e4000e.jpg";